import { useFlag } from 'containers/flags'
import {
  useGetWorkspaceProfileIdentifierQuery,
  useGetWorkspaceQuery,
} from '@sketch/gql-types'

export const useIsProfileEnabled = (identifier: string) => {
  const isProfileFFEnabled = useFlag('profiles')

  const {
    data: workspaceData,
    loading: loadingWorkspaceData,
  } = useGetWorkspaceQuery({
    variables: { identifier },
    skip: !isProfileFFEnabled,
  })

  const {
    data: workspaceProfile,
    loading: loadingWorkspaceProfile,
  } = useGetWorkspaceProfileIdentifierQuery({
    variables: { identifier },
    skip: !isProfileFFEnabled,
  })

  const isProfileCreated = !!workspaceProfile?.workspace.profile?.identifier
  const isWorkspaceProfileEnabled = !!workspaceData?.workspace.features
    .workspaceProfileEnabled

  const isProfileEnabled =
    isProfileFFEnabled && isWorkspaceProfileEnabled && isProfileCreated

  const loading = loadingWorkspaceData || loadingWorkspaceProfile

  return { isProfileEnabled, loading }
}
